<!--Header of page-->
<div class="row ss-top-menu">
  <div class="col-xl-5 col-lg-5 col-md-5 col-sm-5 col-xs-5">
    <span class="ss-text-light" style="vertical-align: -webkit-baseline-middle;">Dashboard <i class="rightArrow fa fa-angle-right"></i> </span>
    <span class="ss-text-dark" style="vertical-align: -webkit-baseline-middle;">Project Purchase Order</span>
  </div>
</div>

<!--Rest of Content-->
<div class="container-fluid">
	<div class="row">
		<div class="col-lg-12 col-md-12 pl-0">
			<!--Cards-->
			<div class="task-cards d-flex negMargin10">
				<a class="nav-link ss-nav-link card p-3 addCursor" id="custom-element-approvals-tab"
				routerLink="." [queryParams]="{tab: 'wip_orders'}"
	      (click)="activateTab('wip_orders')" [ngClass]="{'active': selectedTab == 'wip_orders'}">
	        <div class="card-footer border-top-0 text-center bg-white m-auto">
	          WIP Orders
	        </div>
	      </a>

	      <a class="nav-link ss-nav-link card p-3 ml-2 addCursor" id="custom-element-approvals-tab"
		  routerLink="." [queryParams]="{tab: 'released_orders'}"
	      (click)="activateTab('released_orders')" [ngClass]="{'active': selectedTab == 'released_orders'}">
	        <div class="card-footer border-top-0 text-center bg-white m-auto">
	          Released Orders
	        </div>
	      </a>

			</div>

      <!--Tabs-->
      <div class="row" *ngIf="selectedTab == 'wip_orders'">
		    <div class="component-parent w-100">
		      <app-office-po-component [data]="data"></app-office-po-component>
		    </div>
		  </div>

		  <div class="row" *ngIf="selectedTab == 'released_orders'">
		    <div class="component-parent w-100">
		      <app-release-order-office-maintainance [data]="data"></app-release-order-office-maintainance>
		    </div>
		  </div>

		</div>
	</div>
</div>



// WEBPACK FOOTER //
// ./src/app/platform/category/category/project-po/project-po.component.html